import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import "./reports.css";
import { FileUploader, Button, TextBox } from 'devextreme-react';
import DataGrid, {
    Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format, FilterRow, Paging, Selection,
    HeaderFilter,
    FilterPanel
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import ReportsDownloadCell from '../reportsManagement/reportsDownloadCell.jsx';


export default class Reports extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newDocVisible: false,
            selectedFiles: [],
            reportItems: []
        };

        this.showAddDocument = this.showAddDocument.bind(this);
        this.hideNewDocument = this.hideNewDocument.bind(this);
        this.onSelectedFilesChanged = this.onSelectedFilesChanged.bind(this);
        this.refreshData = this.refreshData.bind(this);
        this.formElement = React.createRef();
        this.onClick = this.onClick.bind(this);
    }

    showAddDocument() {
        this.setState({ newDocVisible: true });
    }

    hideNewDocument() {
        this.setState({ newDocVisible: false });
    }

    onSelectedFilesChanged(e) {
        this.setState({ selectedFiles: e.value });
    }

    onClick() {

        this.formElement.current.submit();
    }

    componentDidMount() {
        this.refreshData();
    }

    refreshData() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/ReportList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ reportItems: data });
            });
    }

    render() {


        return (
            <div>
                <Grid fluid className="positionGrid">                   
                    <Row>
                        <Col lg={12}>
                            <Panel header="Отчёты">
                                <DataGrid
                                    dataSource={this.state.reportItems}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    selection={{ mode: 'single' }}
                                    hoverStateEnabled={true}
                                    showColumnLines={false}
                                    showRowLines={true}
                                    showBorders={false}
                                >
                                   
                                    <HeaderFilter visible={true} />
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={false} />
                                    <Column
                                        dataField={'createDate'}
                                        caption={'Дата публикации'}
                                        dataType={'date'}
                                        width={200}>
                                    </Column>
                                    <Column
                                        dataField={'portfolioName'}
                                        caption={'Портфель'}>
                                    </Column>
                                    <Column
                                        dataField={'description'}
                                        caption={'Комментарий'}>
                                    </Column>
                                    <Column
                                        dataField={'fileName'}
                                        caption={'Файл'}
                                        cellRender={ReportsDownloadCell}
                                    >
                                    </Column>
                                </DataGrid>
                            </Panel>
                        </Col>
                    </Row>
                </Grid>
                <Popup
                    className={'popup'}
                    visible={this.state.newDocVisible}
                    onHiding={this.hideNewDocument}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={'Загрузить отчёты'}
                    width={900}
                    height={600}
                >
                    <div>
                        <Grid fluid>
                            <Row>
                                <Col lg={12}>
                                    <iframe width="0" height="0" border="0" name="dummyframe" id="dummyframe"></iframe>
                                    <form id={'form'} ref={this.formElement}
                                        method="post"
                                        enctype="multipart/form-data"
                                        action="/api/main/UploadReports" target="dummyframe"
                                    >
                                        <TextBox name={'description'} />
                                        <FileUploader selectButtonText={'Выберите файл'} multiple={true} labelText={''} uploadMode={'useForm'} />
                                        <Button className={'downloadButton'} text={'Загрузить'} type={'success'} onClick={this.onClick} />
                                    </form>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </Popup>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./App/containers/reports/reports.jsx